var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"visibility":"inherit"},attrs:{"app":"","id":"bodyDiv"}},[_c('div',[_c('Header'),_c('div',{staticClass:"mdm-main-wrapper"},[_c('div',{staticClass:"mdm-main-wrap"},[_c('router-view')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }